import { GENERIC_PROVIDERS, PROVIDERS, PROVIDER_THEME_MAP } from 'src/config/providers'
import { IDENTITY_PROVIDER_KEY } from 'src/config/storageKeys'
import { oidcConfig_ms, oidcConfig_nkr, oidcConfig_os } from './oidcConfigs'

const PROVIDER_OIDC_CONFIGS = {
  [PROVIDERS.OTTO_SCHMIDT]: oidcConfig_os,
  [PROVIDERS.NKR]: oidcConfig_nkr,
  [PROVIDERS.MICROSOFT]: oidcConfig_ms,
  [PROVIDERS.MS]: oidcConfig_ms,
  [PROVIDERS.REHM]: oidcConfig_ms,
  [PROVIDERS.LINDE]: oidcConfig_ms,
  [PROVIDERS.REGUVIS]: oidcConfig_ms,
  [PROVIDERS.STAEMPFLI]: oidcConfig_ms,
  [PROVIDERS.ERICH_SCHMIDT]: oidcConfig_ms,
}

export function getOidcConfigForProvider(provider) {
  return PROVIDER_OIDC_CONFIGS[provider] || oidcConfig_os
}

export function readStoredProvider() {
  try {
    return JSON.parse(localStorage.getItem(IDENTITY_PROVIDER_KEY)) || null
  } catch (error) {
    return null
  }
}

export function storeProvider(provider) {
  try {
    localStorage.setItem(IDENTITY_PROVIDER_KEY, JSON.stringify(provider))
  } catch (error) {
    // ignore
  }
}

export function getPreferredThemeFromLoginProvider() {
  const stored = readStoredProvider()
  if (!stored || GENERIC_PROVIDERS.has(stored)) return undefined
  return PROVIDER_THEME_MAP[stored]
}
